import React, { cloneElement } from 'react';
import { Avatar } from 'components/ui';
import Logo from 'components/template/Logo';
import { APP_NAME } from 'constants/app.constant';
import { Link } from 'react-router-dom';

const Side = ({ children, content, ...rest }) => {
  return (
    <div className="grid lg:grid-cols-3 h-full">
      <div
        className="bg-no-repeat bg-cover py-6 px-16 flex-col justify-between hidden lg:flex"
        style={{
          backgroundImage: `url('/img/others/auth-side-bg.jpg')`,
        }}
      >
        <Link to={'/'}>
          <Logo mode="dark" />
        </Link>
        <div>
          {/* <div className="mb-6 flex items-center gap-4">
            <Avatar
              className="border-2 border-white"
              shape="circle"
              src="/img/avatars/thumb-10.jpg"
            />
            <div className="text-white">
              <div className="font-semibold text-base">Jefferson Braga Louback</div>
              <span className="opacity-80">Co-Founder, DrDerma</span>
            </div>
          </div> */}
          <h4 className="text-white text-2xl mb-4">Bem vindo!</h4>
          <p className="text-lg text-white opacity-80 text-justify mb-2">
            Se você tem algum problema dermatológico — como lesões na pele, alterações nas
            unhas, cabelos ou mucosas — a DRDERMA pode te ajudar com avaliações e
            tratamentos online ou offline (com resposta em até 24h).
          </p>
          <p className="text-lg text-white opacity-80 text-justify mb-2">
            Basta preencher um formulário, enviar fotos ou falar diretamente com o médico
            para receber a orientação necessária.
          </p>
          <p className="text-lg text-white opacity-80 text-justify mb-2">
            Além disso, a DRDERMA também atua na prevenção do câncer de pele, como o
            melanoma, que pode surgir de uma simples pinta.
          </p>

          <p className="text-lg text-white opacity-80 text-justify">
            Conte conosco para cuidar da sua saúde dermatológica!
          </p>
        </div>
        <span className="text-white">
          Copyright &copy; {`${new Date().getFullYear()}`}{' '}
          <span className="font-semibold">{`${APP_NAME}`}</span>{' '}
        </span>
      </div>
      <div className="col-span-2 flex flex-col justify-center items-center bg-white dark:bg-gray-800">
        <div className="xl:w-[450px] px-8">
          <div className="mb-8">{content}</div>
          {children ? cloneElement(children, { ...rest }) : null}
        </div>
      </div>
    </div>
  );
};

export default Side;
